"use client";
import * as React from "react";
import classNames from "classnames";
import { blue } from "@ant-design/colors";
import Context from "./Context";
import ReactIcon from "./IconBase";
import { getTwoToneColor, setTwoToneColor } from "./twoTonePrimaryColor";
import { normalizeTwoToneColors } from "../utils";
// Initial setting
// should move it to antd main repo?
setTwoToneColor(blue.primary);
const Icon = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { // affect outter <i>...</i>
    className, // affect inner <svg>...</svg>
    icon, spin, rotate, tabIndex, onClick, // other
    twoToneColor, ...restProps } = props;
    const { prefixCls = "anticon", rootClassName } = React.useContext(Context);
    const classString = classNames(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === "loading"
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) {
        iconTabIndex = -1;
    }
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = normalizeTwoToneColors(twoToneColor);
    return /*#__PURE__*/ React.createElement("span", {
        role: "img",
        "aria-label": icon.name,
        ...restProps,
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }, /*#__PURE__*/ React.createElement(ReactIcon, {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
Icon.displayName = "AntdIcon";
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
export default Icon;
